import { RedoOutlined } from "@ant-design/icons";
import { Button, ButtonProps, Tooltip } from "antd"
import React from "react";

interface RefreshButtonProps {
    buttonProps?: ButtonProps,
    iconProps?: React.ComponentProps<typeof RedoOutlined>,
    tooltipProps?: React.ComponentProps<typeof Tooltip>,
    onClick: (event: any) => void,
    disabled: boolean,
    loading: boolean,
}
export const RefreshButtonNew = (props: React.PropsWithChildren<RefreshButtonProps>) => {
    const { buttonProps } = props;

    return (
        <Tooltip {...props} title="Refresh data from bin device" {...props.tooltipProps}>
            <Button icon={<RedoOutlined spin={props.loading} {...props.iconProps} />} ghost={false} type="primary" disabled={props.disabled} {...buttonProps}>
                {props.children}
            </Button>
        </Tooltip>
    );
}